/* Ashcroft London — lux motion layer (pairs with ashcroft-lux.css)
   Scroll reveals + hero reveal fallback. No dependencies. */
(function () {
  'use strict';

  document.documentElement.classList.add('ash-js');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // Hero reveal fallback: the masked rise-up in apex-styles waits for
    // a `loaded` class on the hero. Guarantee it fires.
    setTimeout(function () {
      var heroes = document.querySelectorAll('[data-aos="amz-hero__anim"]');
      for (var i = 0; i < heroes.length; i++) heroes[i].classList.add('loaded');
    }, 400);

    if (reducedMotion || !('IntersectionObserver' in window)) return;

    var targets = [];

    // Homepage / content sections: reveal the section wrapper itself.
    // Skip the hero (it has its own entrance) and anything above the fold.
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    for (var s = 0; s < sections.length; s++) {
      var el = sections[s];
      if (el.querySelector('.video-parent-section, [data-aos="amz-hero__anim"]')) continue;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.6) continue;
      el.classList.add('ash-reveal');
      targets.push(el);
    }

    // Product cards: stagger within each row.
    var cards = document.querySelectorAll('.grid__item.amz-gp');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      if (card.closest('.ash-reveal')) continue; // section already reveals as one
      if (card.getBoundingClientRect().top < window.innerHeight * 0.9) continue;
      card.classList.add('ash-reveal');
      card.style.setProperty('--ash-d', (c % 4) * 0.09 + 's');
      targets.push(card);
    }

    // Product page gallery images scroll in as a column (desktop grid layout).
    if (window.matchMedia('(min-width: 769px)').matches) {
      var media = document.querySelectorAll('.product-section--amz-grid-media .amz-desktop-media__item');
      for (var m = 0; m < media.length; m++) {
        if (media[m].getBoundingClientRect().top < window.innerHeight * 0.9) continue;
        media[m].classList.add('ash-reveal');
        targets.push(media[m]);
      }
    }

    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e++) {
        if (entries[e].isIntersecting) {
          entries[e].target.classList.add('ash-in');
          observer.unobserve(entries[e].target);
        }
      }
    }, { rootMargin: '0px 0px -8%', threshold: 0.08 });

    for (var t = 0; t < targets.length; t++) observer.observe(targets[t]);

    // Safety net: never leave content hidden.
    setTimeout(function () {
      for (var t2 = 0; t2 < targets.length; t2++) targets[t2].classList.add('ash-in');
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
